import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import axios from 'axios';
import Loading from './components/loading/Loading';
import { useForm, Controller } from "react-hook-form";
import { format } from 'date-fns';
import Swal from 'sweetalert2';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function LeaseAgreementForm() {
    const navigate = useNavigate();
    const {
        control,
        register,
        handleSubmit,
        formState: { errors },
        getValues,
        reset
    } = useForm();


    const location = useLocation();
    const id = decodeURIComponent(location.pathname.split('/leaseform/')[1]);
    const [leaseAgreementBody, setLeaseAgreementBody] = useState('');
    const [item, setItem] = useState({
        negotiation: {},
        images: []
    });
    const [loading, setLoading] = useState(true);
    const [clientDetail, setClientDetail] = useState([]);
    const [ownerDetail, setOwnerDetail] = useState([]);

    useEffect(() => {
        // debugger;
        async function getGarage() {
            try {
                setLoading(true);
                // console.log('negotiationID', id);

                const negotiation = await axios.post(`${process.env.REACT_APP_API_URL}`, {
                    action: 'GetNegotiations_byID',
                    id: id,
                })
                    .then(response => {
                        if (response.data.status === true) {
                            return response.data.data;
                        } else {
                            Swal.fire({
                                icon: 'info',
                                title: response.data.message,
                            });
                            navigate('/')
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    });
                //console.log('negotiation', negotiation)
                const data = await axios.post(`${process.env.REACT_APP_API_URL}`, {
                    action: 'GetGaragebyId',
                    id: negotiation.garageID,
                })
                    .then(response => {
                        //  console.log('garage details', response.data.data);
                        if (response.data.status === true) {
                            return response.data.data;
                        } else {
                            Swal.fire({
                                icon: 'info',
                                title: response.data.message,
                            });
                            navigate('/')
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    });

                const urlsArray = data.garagePictures;
                let imagesURL = [];
                if (urlsArray.length>0) {
                    for (const image in urlsArray) {
                        imagesURL = [...imagesURL, process.env.REACT_APP_UPLOAD_URL + urlsArray[image]];
                    }
                } else {
                    imagesURL = ['./assets/Images/garage-placeholder.png'];
                }
                setItem(prev => ({
                    ...prev,
                    ...data,
                    negotiation: { ...negotiation },
                    images: imagesURL
                }));
                setLoading(false);
            } catch (error) {
                console.log(error);
                throw error;
            }
        }

        getGarage();
    }, [id]);

    useEffect(() => {
        if (item.negotiation.ownerID) {
            (async () => {
                //  console.log('item.negotiation.ownerID', item.negotiation.ownerID)
                const response = await axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'GetUserbyId', id: item.negotiation.ownerID });
                const userMetaq = response.data.data;
                setOwnerDetail(userMetaq)
                // console.log('userMetaq', userMetaq)
            })();
        }
    }, [item.negotiation.ownerID]);



    useEffect(() => {
        if (item.negotiation.clientID) {
            (async () => {
                // console.log('item.negotiation.clientID', item.negotiation.clientID)
                const response = await axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'GetUserbyId', id: item.negotiation.clientID });
                const userMetaq = response.data.data;
                setClientDetail(userMetaq)
                // console.log('userMetaq', userMetaq)
            })();
        }
    }, [item.negotiation.clientID]);

    useEffect(() => {
        reset({
            ownerName: ownerDetail.firstname + ' ' + ownerDetail.lastname || '',
            ownerAddress: ownerDetail.mailingAddress || '',
            ownerPhone: ownerDetail.phoneNumber || '',
            ownerEmail: ownerDetail.email || '',
            renterName: clientDetail.firstname + ' ' + clientDetail.lastname || '',
            renterAddress: clientDetail.mailingAddress || '',
            renterPhone: clientDetail.phoneNumber || '',
            renterEmail: clientDetail.email || '',
            placeAddress: item.address || '',
            placeDescription: item.description || '',
            placeCounty: 'US' || '',
            placeState: item.state || '',
            rentalRate: item.negotiation.currentProposal || '',
            deposit: item.deposit || '',
            lateCharge: item.lateCharge || '',
            bounceFee: item.bounceFee || '',
            noofmonths: item.noofmonths || '',
            leaseStartDate: item.start_date && item.start_date !== '0000-00-00' ? new Date(item.start_date) : null || '',
            // rentPaymentDay: dataEdit.businessURL || '',
            paymentProvider: 'STRIPE' || '',
            // storageType: dataEdit.businessURL || '',
            // activeMilitary: dataEdit.businessURL || '',
            // commChoice: dataEdit.businessURL || '',
            // lateLetterCharge: dataEdit.businessURL || '',
            // lienLetterCharge: dataEdit.businessURL || '',
            // advertising: dataEdit.businessURL || '',
            // inventory: dataEdit.businessURL || ''
        });
        handleChange();
        // console.log('item', item)
    }, [clientDetail, ownerDetail, item, reset]);





    const populateLeaseAgreementBody = (data) => {
        const ownerName = data.ownerName;
        const ownerAddress = document.getElementById("ownerAddress").value;
        const ownerPhone = document.getElementById("ownerPhone").value;
        const ownerEmail = document.getElementById("ownerEmail").value;
        const renterName = document.getElementById("renterName").value;
        const renterAddress = document.getElementById("renterAddress").value;
        const renterPhone = document.getElementById("renterPhone").value;
        const renterEmail = document.getElementById("renterEmail").value;
        const alternateName = document.getElementById("alternateName").value;
        const alternateAddress = document.getElementById("alternateAddress").value;
        const alternatePhone = document.getElementById("alternatePhone").value;
        const alternateEmail = document.getElementById("alternateEmail").value;
        const placeAddress = document.getElementById("placeAddress").value;
        const placeDescription = document.getElementById("placeDescription").value;
        const placeCounty = document.getElementById("placeCounty").value;
        const placeState = document.getElementById("placeState").value;
        const rentalRate = document.getElementById("rentalRate").value;
        const deposit = document.getElementById("deposit").value;
        const lateCharge = document.getElementById("lateCharge").value;
        const bounceFee = document.getElementById("bounceFee").value;
        const leaseAgreeDate = document.getElementById("leaseAgreeDate").value;
        const leaseStartDate = data.leaseStartDate;
        const rentPaymentDay = document.getElementById("rentPaymentDay").value;
        const paymentProvider = document.getElementById("paymentProvider").value;
        const storageType = document.getElementById("storageType").value;
        const activeMilitary = document.getElementById("activeMilitary").value;
        const commChoice = document.getElementById("commChoice").value;
        const lateLetterCharge = document.getElementById("lateLetterCharge").value;
        const lienLetterCharge = document.getElementById("lienLetterCharge").value;
        const advertising = document.getElementById("advertising").value;
        const inventory = document.getElementById("inventory").value;


        const commValue = {
            "1": "** OCCUPANT WISHES TO RECEIVE E-MAIL COMMUNICATIONS AND TEXT MESSAGES WITH REGARDS TO THIS AGREEMENT. By choosing the option to receive e-mail/text communication in this agreement, Owner will provide Occupant notices and other information regarding your account through e-mail/text to the mobile phone numbers and email addresses provided by Occupant in the tenant profile, or in a subsequent written change of mobile phone numbers or email addresses, and such change has been provided to Owner",
            "2": "** Occupant elects to receive all communication by First Class U.S. Postal Service",
            "default": "communication choice NOT selected"
        }[commChoice];

    };


    const startDataCollection = (data) => {
        Swal.fire({
            title: 'Saving, please wait',
            html:
                '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
            showConfirmButton: false,
            showCancelButton: false,
            focusConfirm: false,
        });
        const formData = new FormData();
        formData.append('action', 'AddContract');
        formData.append('negotiation', id);
        formData.append('garage', item.negotiation.garageID);
        formData.append('clientid', item.negotiation.clientID);
        formData.append('ownerid', item.negotiation.ownerID);
        formData.append('ownerName', data.ownerName);
        formData.append('ownerPhone', data.ownerPhone);
        formData.append('ownerEmail', data.ownerEmail);
        formData.append('ownerAddress', data.ownerAddress);
        formData.append('renterName', data.renterName);
        formData.append('renterAddress', data.renterAddress);
        formData.append('renterPhone', data.renterPhone);
        formData.append('renterEmail', data.renterEmail);
        formData.append('alternateName', data.alternateName);
        formData.append('alternateAddress', data.alternateAddress);
        formData.append('alternatePhone', data.alternatePhone);
        formData.append('alternateEmail', data.alternateEmail);
        formData.append('placeAddress', data.placeAddress);
        formData.append('placeDescription', data.placeDescription);
        formData.append('placeCounty', data.placeCounty);
        formData.append('placeState', data.placeState);
        formData.append('rentalRate', data.rentalRate);
        formData.append('deposit', data.deposit);
        formData.append('lateCharge', data.lateCharge);
        formData.append('bounceFee', data.bounceFee);
        formData.append('leaseAgreeDate', data.leaseAgreeDate);
        formData.append('leaseStartDate', format(data.leaseStartDate, 'yyyy/MM/dd'));
        formData.append('rentPaymentDay', data.rentPaymentDay);
        formData.append('paymentProvider', data.paymentProvider)
        formData.append('storageType', data.storageType)
        formData.append('activeMilitary', data.activeMilitary)
        formData.append('commChoice', data.commChoice)
        formData.append('lateLetterCharge', data.lateLetterCharge)
        formData.append('lienLetterCharge', data.lienLetterCharge)
        formData.append('advertising', data.advertising)
        formData.append('inventory', data.inventory)
        formData.append('startdate', format(data.leaseStartDate, 'yyyy/MM/dd'))
        formData.append('enddate', format(endDate, 'yyyy/MM/dd'))
        formData.append('noofmonths', data.noofmonths)
        axios.post(`${process.env.REACT_APP_API_URL}`, formData)
            .then(response => {
                console.log(response.data);
                Swal.close();
                if (response.data.status === true) {
                    Swal.fire(
                        'Success!!',
                        response.data.message,
                        'success'
                    )
                        .then(() => {
                            navigate('/leaseformedit/' + response.data.data);
                        })
                } else {
                    Swal.fire(
                        'Oops...m',
                        `Something went wrong creating the garage. ${response.data.message}`,
                        'error'
                    );
                }
            })
            .catch(error => {
                Swal.close();
                Swal.fire(
                    'Oops...m',
                    `Something went wrong creating the garage ${error}`,
                    'error'
                );
            });

    };

    function SendContractToBuyer() {
        Swal.fire(
            'Please Save Contract',
            `Please Save Contract`,
            'info'
        );
    }

    const [endDate, setEndDate] = useState();
    const [messageendDate, setMessageendDate] = useState();

    const handleChange = () => {
        const noofmonths = getValues("noofmonths");
        const startdateStr = getValues("leaseStartDate");

        if (!startdateStr || startdateStr === '0000-00-00' || isNaN(Date.parse(startdateStr))) {
            console.error('Invalid start date:', startdateStr);
            return;
        }

        const startdate = new Date(startdateStr);

        if (noofmonths > 0 && noofmonths <= 36) {
            const newDate = new Date(startdate);
            newDate.setMonth(newDate.getMonth() + parseInt(noofmonths, 10));

            setEndDate(newDate);
            setMessageendDate(`Garage end date will be ${format(newDate, 'MM/dd/yyyy')}`);
        }
    }
    return loading ? (
        <Loading text={"Loading Negotiation Details"} />
    ) : (
        <section className="page-content sec-padding">
            <div className="container-fluid">
                <div className='row'>
                    <form id="leaseForm" className='col-md-6' onSubmit={handleSubmit(startDataCollection)}>
                        <h1>Lease Form</h1>
                        <fieldset>
                            <legend>Owner/Landlord Information</legend>
                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="ownerName">Owner/Landlord Name:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="ownerName" name="ownerName"  {...register("ownerName", { required: true })} className='form-control' />
                                    {errors.ownerName && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Owner/Landlord Name is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="ownerAddress">Owner Mailing Address:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="ownerAddress" name="ownerAddress"  {...register("ownerAddress", { required: true })} className='form-control' />
                                    {errors.ownerAddress && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Owner Mailing Address is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="ownerPhone">Owner Phone:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="tel" id="ownerPhone" name="ownerPhone"  {...register("ownerPhone", { required: true })} className='form-control' />
                                    {errors.ownerPhone && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Owner Phone is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="ownerEmail">Owner Email:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="ownerEmail" className='form-control'
                                        {...register("ownerEmail", {
                                            required: "Owner Email is required",
                                            pattern: {
                                                value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.(com|org)$/,
                                                message: "Entered value does not match email format",
                                            },
                                        })} name="ownerEmail" />
                                    {errors.ownerEmail && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">{errors.ownerEmail.message}</span>
                                        </span>
                                    )}
                                </div>
                            </div>
                        </fieldset>

                        <fieldset>
                            <legend>Renter Information</legend>
                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="renterName">Renter:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="renterName" name="renterName" {...register("renterName", { required: true })} className='form-control' />
                                    {errors.renterName && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Renter is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="renterAddress">Mailing Address of Renter:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="renterAddress" name="renterAddress" {...register("renterAddress", { required: true })} className='form-control' />
                                    {errors.renterAddress && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Mailing Address is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="renterPhone">Renter Phone:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="tel" id="renterPhone" name="renterPhone"  {...register("renterPhone", { required: true })} className='form-control' />
                                    {errors.renterPhone && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Renter Phone is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>



                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="renterEmail">Renter Email:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="email" id="renterEmail" className='form-control'
                                        {...register("renterEmail", {
                                            required: "Renter Email is required",
                                            pattern: {
                                                value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.(com|org)$/,
                                                message: "Entered value does not match email format",
                                            },
                                        })} name="renterEmail" />
                                    {errors.renterEmail && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">{errors.renterEmail.message}</span>
                                        </span>
                                    )}
                                </div>
                            </div>
                        </fieldset>

                        <fieldset>
                            <legend>Alternate Contact Person</legend>
                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="alternateName">Alternate Name:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="alternateName" {...register("alternateName", { required: true })} name="alternateName" className='form-control' />
                                    {errors.alternateName && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Alternate Nam is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="alternateAddress">Alternate Mailing Address:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="alternateAddress" {...register("alternateAddress", { required: true })} name="alternateAddress" className='form-control' />
                                    {errors.alternateAddress && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Alternate Mailing Address is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="alternatePhone">Alternate Phone:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="tel" id="alternatePhone" {...register("alternatePhone", { required: true })} name="alternatePhone" className='form-control' />
                                    {errors.alternatePhone && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Alternate Phone is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>


                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="alternateEmail">Alternate Email:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="email" id="alternateEmail"
                                        {...register("alternateEmail", {
                                            required: "Alternate Email is required",
                                            pattern: {
                                                value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.(com|org)$/,
                                                message: "Entered value does not match email format",
                                            }
                                        })}
                                        className='form-control' name="alternateEmail" />
                                    {errors.alternateEmail && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">{errors.alternateEmail.message}</span>
                                        </span>
                                    )}
                                </div>
                            </div>
                        </fieldset>

                        <fieldset>
                            <legend>Lease Details</legend>

                            <div className='form-group row'>
                                <label className='form-label col-md-4 label-selectable' htmlFor="leaseAgreeDate">Lease Agreement Date:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="date" id="leaseAgreeDate" {...register("leaseAgreeDate", { required: true })} name="leaseAgreeDate" className='form-control' />
                                    {errors.leaseAgreeDate && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Lease Agreement Date is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="placeAddress">Place Address:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="placeAddress"
                                        {...register("placeAddress", { required: true })} name="placeAddress" className='form-control' />
                                    {errors.placeAddress && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Place Address is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="placeDescription">Place Further Description:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="placeDescription" {...register("placeDescription", { required: true })} name="placeDescription" className='form-control' />
                                    {errors.placeDescription && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Place Further Description is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="placeCounty">Place County:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="placeCounty" {...register("placeCounty", { required: true })} name="placeCounty" value="US" className='form-control' />
                                    {errors.placeCounty && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Place County is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="placeState">Place State:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="placeState" {...register("placeState", { required: true })} name="placeState" className='form-control' />
                                    {errors.placeState && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Place State is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="rentalRate">Rental rate:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="rentalRate" name="rentalRate"
                                      onKeyUp={(e) => {
                                        e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                                    }}
                                        {...register("rentalRate", { required: true })} className='form-control' />
                                    {errors.rentalRate && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Rental rate is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="deposit">Deposit:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="deposit" name="deposit"
                                    onKeyUp={(e) => {
                                        e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                                    }}
                                        {...register("deposit", { required: true })} className='form-control' />
                                    {errors.deposit && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Deposit is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="lateCharge">Late Charge:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="lateCharge" name="lateCharge"
                                      onKeyUp={(e) => {
                                        e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                                    }}
                                        {...register("lateCharge", { required: true })} className='form-control' />
                                    {errors.lateCharge && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Late Charge is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="bounceFee">Bounce fee:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="bounceFee" name="bounceFee"
                                       onKeyUp={(e) => {
                                        e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                                    }}
                                        {...register("bounceFee", { required: true })} className='form-control' />
                                    {errors.bounceFee && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Bounce fee is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="form-label col-md-4" htmlFor="leaseStartDate">Lease Start Date:</label>
                                <div className="col-md-8 d-flex position-relative">
                                    <Controller
                                        control={control}
                                        name="leaseStartDate"
                                        rules={{ required: true }}
                                        render={({ field }) => (
                                            <DatePicker
                                                selected={field.value}
                                                onChange={(date) => {
                                                    field.onChange(date);
                                                    handleChange();
                                                }}
                                                dateFormat="MM/dd/yyyy"
                                                placeholderText="MM/dd/yyyy"
                                                minDate={new Date()}
                                                showYearDropdown
                                                showMonthDropdown
                                                dropdownMode="select"
                                                className="form-control"
                                            />
                                        )}
                                    />
                                    {errors.leaseStartDate &&
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Lease Start Date is required!</span>
                                        </span>
                                    }
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="form-label col-md-4" htmlFor="noofmonths"> Number of months:</label>
                                <div className="col-md-8 d-flex position-relative">
                                    <Controller
                                        control={control}
                                        name="noofmonths"
                                        rules={{
                                            required: "Number of months is required",
                                            validate: (value) => {
                                                const intValue = parseInt(value);
                                                if (intValue <= 0) return "The value should be greater than 0";
                                                if (intValue > 36) return "The maximum value is 36";
                                                return true;
                                            },
                                        }}
                                        render={({ field }) => (
                                            <input
                                                value={field.value}
                                                type="text"
                                                onKeyUp={(e) => {
                                                    e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                                                }}
                                                minLength={1}
                                                className="form-control"
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    handleChange();
                                                }}

                                            />

                                        )}
                                    />

                                    {errors.noofmonths &&
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">{errors.noofmonths.message}</span>
                                        </span>
                                    }
                                </div>
                            </div>
                            <div className="form-group text-center">
                                {messageendDate}
                            </div>


                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="rentPaymentDay">Rent Payment Day:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="date" id="rentPaymentDay" name="rentPaymentDay" {...register("rentPaymentDay", { required: true })} className='form-control' />
                                    {errors.rentPaymentDay && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Rent Payment Day is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="paymentProvider">Electronic Payment Provider:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" readOnly={true} id="paymentProvider" name="paymentProvider" {...register("paymentProvider", { required: true })} value="STRIPE" className='form-control' />
                                    {errors.paymentProvider && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Electronic Payment Provider is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="storageType">Storage Type:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="storageType" name="storageType" {...register("storageType", { required: true })} className='form-control' />
                                    {errors.storageType && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Storage Type is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="lateLetterCharge">Late Letter Charge:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="lateLetterCharge" name="lateLetterCharge"
                                        onKeyUp={(e) => {
                                            e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                                        }}
                                        {...register("lateLetterCharge", { required: true })} className='form-control' />
                                    {errors.lateLetterCharge && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Late Letter Charge is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="lienLetterCharge">Lien Letter Charge:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="lienLetterCharge" name="lienLetterCharge"
                                        onKeyUp={(e) => {
                                            e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                                        }}
                                        {...register("lienLetterCharge", { required: true })} className='form-control' />
                                    {errors.lienLetterCharge && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Lien Letter Charge is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="advertising">Advertising Cost:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="advertising" name="advertising"
                                      onKeyUp={(e) => {
                                        e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                                    }}
                                        {...register("advertising", { required: true })} className='form-control' />
                                    {errors.advertising && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Advertising Cost is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="inventory">Inventory:</label>
                                <div className='col-md-8 position-relative'>
                                    <input type="text" id="inventory" name="inventory" {...register("inventory", { required: true })} className='form-control' />
                                    {errors.inventory && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Inventory is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="activeMilitary">Active Military:</label>
                                <div className='col-md-8 position-relative'> <select id="activeMilitary" name="activeMilitary" className='form-select' {...register("activeMilitary", { required: true })}>
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                                    {errors.activeMilitary && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Active Military is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className='form-group row'>
                                <label className='form-label col-md-4' htmlFor="commChoice">Communication Choice:</label>
                                <div className='col-md-8 position-relative'> <select id="commChoice" name="commChoice" className='form-select' {...register("commChoice", { required: true })} >
                                    <option value="">Select</option>
                                    <option value="U.S. Postal Service">U.S. Postal Service</option>
                                    <option value="E-mail">E-mail</option>
                                </select>
                                    {errors.commChoice && (
                                        <span className="text-danger la la-exclamation-circle error-icon">
                                            <span className="badge badge-danger error-icon-text">Communication Choice is required!</span>
                                        </span>
                                    )}
                                </div>
                            </div>

                        </fieldset>
                        <div className='form-group'>
                            <button type="submit" className='btn btn-primary btn-lg me-3'>Save Contract</button>
                            {/* Button for printing lease agreement */}

                        </div>
                        <div className='form-group row'>
                            <span className='text-danger'>NOTE: After saving the contract, kindly submit it to the tenant by clicking the "Submit To Tenant" button located on the right-hand side.</span>
                        </div>
                    </form>
                    <div className='col-md-6'>

                        {/* Body of Lease Agreement */}
                        <h1>Body of Lease Agreement</h1>
                        <textarea
                            id="leaseAgreementBody"
                            rows="50"
                            cols="100"
                            readOnly
                            value={leaseAgreementBody}
                        // onChange={(e) => setLeaseAgreementBody(e.target.value)} // If you want to allow editing
                        />
                        <button type="submit" className='btn btn-lg btn-primary me-3' onClick={SendContractToBuyer} >Submit to Tenant</button>

                        <button type="submit" className='btn btn-lg btn-primary' onClick={SendContractToBuyer}>Print Lease Agreement</button>


                    </div>
                </div>
            </div >
        </section >
    );
}

export default LeaseAgreementForm;
